<template>
  <b-card no-body class="wrapper" v-if="lookups">
    <b-card-body>
      <b-card-text>
        <div class="label">Invalid Reason</div>
        <div class="text">
          <b-form-select
            id="answer"
            v-model="selectedReason"
            :options="invalidDetailsReasons"
            value-field="id"
            text-field="randDName"
          >
          </b-form-select>
        </div>

        <div v-if="selectedReason == otherId">
          <div class="label">Other Reason</div>
          <div class="text">
            <b-form-textarea id="other" v-model="otherReason">
            </b-form-textarea>
          </div>
        </div>

        <div class="text">
          <b-button class="mt-3" variant="success" block @click="saveReason" :disabled="!selectedReason">
            <font-awesome-icon icon="check" /> Confirm
          </b-button>

          <b-button
            class="mt-3"
            variant="danger"
            block
            @click="$parent.showDispositions"
          >
            <font-awesome-icon icon="times" /> Cancel
          </b-button>
        </div>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>

import DataSelectionService from "@/services/DataSelection.service";

export default {
  name: "InvalidReason",
  props: {
    companyId: String,
    lookups: Object,
  },
  data() {
    return {
      selectedReason: null,
      otherReason: null,
      otherId: 900,
    };
  },
  computed: {
    invalidDetailsReasons() {
      if (!this.lookups) return [];

      var array = [...this.lookups.invalidDetailsReasons];

      if (array[0].id == 0) {
        array[0].disabled = true
      }

      return array;
    }
  },
  methods: {
    saveReason() {
      this.isBusy = true;

       this.$http.post("/company/invalid/",
        {
          companyId: this.companyId,
          invalidReasonId: this.selectedReason,
          invalidReasonOther: this.otherReason
        }).then(() => {
          this.isBusy = false;

          if(this.$route.name == "CompanyCall") {
            DataSelectionService.getNextCompany().then(result => {
              if(result && result.data != 0) {
                this.$router.push("/call/" + result.data);

              } else {
                this.$router.push("/getnext");
              }
            });

          } else {
            this.$parent.reloadData();
            this.$parent.showDispositions();
          }
      });
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: 600;
}
.text {
  margin-bottom: 10px;
}
.wrapper {
  margin-top: 10px;
}
</style>
